import React from 'react'
import CustomTextField from './CustomTextField'
import CustomSwitchField from './CustomSwitchField'
import CustomButton from './CustomButton'
import CustomMenuField from './CustomMenuField'
import BaseField from './BaseField'
import CustomUnknown from './CustomUnknown'
import CustomTable from './CustomTable'
import CustomRichText from './CustomRichText/CustomRichText'
import {
  CustomDate,
  CustomDateTime,
} from 'shared-ui/components/atoms/CustomDatePicker/CustomPickers'
import CustomTimeStamp from 'shared-ui/components/atoms/CustomDatePicker/CustomTimeStamp'
import CustomMultipleMenu from './CustomMultipleMenu'
import CustomReference from './CustomReference'
import CustomDivider from './CustomDivider'
import CustomColor from './CustomColor'
import CustomJSON from './CustomJSON'
import CustomMedia from './CustomMedia/CustomMedia'
import CustomUserMedia from './CustomMedia/CustomUserMedia'
import Icon from '@material-ui/core/Icon'
import InputAdornment from '@material-ui/core/InputAdornment'
import CustomNumber from './CustomNumber'
import CustomVReference from './CustomVReference'
import SegmentationQuery from './SegmentationQuery'
import SurveyQuestionEnumOptions from './SurveyQuestionEnumOptions'
import ContentElements from './ContentElements'
import CustomScript from './CustomScript'
import CustomRadioField from './CustomRadioField'
import CustomCheckBoxField from './CustomCheckBoxField'
import JsonTable from './JsonTable'
import StaticContentElement from '~components/atom/FieldFactory/ContentElements/StaticContentElement'
import CustomGeoPoint from '~components/atom/FieldFactory/CustomGeoPoint'
import CustomChipsInput from '~components/atom/FieldFactory/CustomChipsInput'

class FieldFactory {
  static getFieldByType(item) {
    let CustomSelection
    let icon
    const { settings: { variant } = {}, type } = item

    switch (type) {
      case 'buffer':
      case 'text':
        icon = 'title'
        switch (variant) {
          case 'script':
            CustomSelection = CustomScript
            break
          default:
            CustomSelection = CustomTextField
        }
        break
      case 'url':
        icon = 'link'
        CustomSelection = CustomTextField
        break
      case 'email':
        icon = 'alternate_email'
        CustomSelection = CustomTextField
        break
      case 'password':
        icon = 'lock'
        CustomSelection = CustomTextField
        break
      case 'integer' || 'Integer':
        CustomSelection = CustomNumber
        break
      case 'float':
        CustomSelection = CustomNumber
        break
      case 'slug':
        CustomSelection = CustomTextField
        break
      case 'date':
        icon = 'date_range'
        CustomSelection = CustomDate
        break
      case 'datetime':
        icon = 'date_range'
        CustomSelection = CustomDateTime
        break
      case 'timestamp':
        icon = 'schedule'
        CustomSelection = CustomTimeStamp
        break
      case 'boolean':
        CustomSelection = CustomSwitchField
        break
      case 'button':
        CustomSelection = CustomButton
        break
      case 'enum' || 'Enum':
        switch (variant) {
          case 'radio':
            CustomSelection = CustomRadioField
            break
          default:
            CustomSelection = CustomMenuField
        }
        break
      case 'multiple':
        switch (variant) {
          case 'checkbox':
            CustomSelection = CustomCheckBoxField
            break
          default:
            CustomSelection = CustomMultipleMenu
        }
        break
      case 'table':
        CustomSelection = CustomTable
        break
      case 'richtext':
        CustomSelection = CustomRichText
        break
      case 'reference':
        CustomSelection = CustomReference
        break
      case 'link':
        CustomSelection = CustomVReference
        break
      case 'divider':
        CustomSelection = CustomDivider
        break
      case 'json':
        switch (variant) {
          case 'segmentation':
            CustomSelection = SegmentationQuery
            break
          case 'surveyQuestionEnumOptions':
            CustomSelection = SurveyQuestionEnumOptions
            break
          case 'contentElements':
          case 'contentSubElements':
            CustomSelection = ContentElements
            break
          case 'learningContent':
            CustomSelection = StaticContentElement
            break
          case 'table':
            CustomSelection = JsonTable
            break
          default:
            CustomSelection = CustomJSON
        }
        break
      case 'media':
        CustomSelection = CustomMedia
        break
      case 'usermedia':
        CustomSelection = CustomUserMedia
        break
      case 'color':
        CustomSelection = CustomColor
        break
      case 'geopoint':
        CustomSelection = CustomGeoPoint
        break
      case 'chips':
        CustomSelection = CustomChipsInput
        break
      default:
        CustomSelection = CustomUnknown
        break
    }

    const InputProps = item.InputProps || {}

    if (icon) {
      const alpha = item.disabled ? 0.25 : 0.54
      InputProps.startAdornment = (
        <InputAdornment style={item.multiline ? { height: '1em' } : null} position="start">
          <Icon style={{ color: `rgba(0,0,0,${alpha})` }}>{icon}</Icon>
        </InputAdornment>
      )
    }

    const { api } = item

    return (
      <BaseField {...item} InputProps={InputProps} api={api}>
        <CustomSelection />
      </BaseField>
    )
  }
}

export default FieldFactory
